<template>
  <section>
    <b-container fluid>
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Rejoignez le réseau social des musiciens amateurs !</h2>
        </b-col>
      </b-row>
      <b-row align-v="center" class="section-content">
        <b-col
          cols="12"
          sm="10"
          offset-sm="1"
          md="8"
          offset-md="2"
          lg="6"
          offset-lg="3"
          xl="4"
          offset-xl="4"
        >
          <b-card no-body>
            <b-tabs pills card>
              <b-tab title="Connexion" active>
                <UserLogin/>
              </b-tab>
              <b-tab title="Inscription">
                <UserRegister/>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import UserLogin from "./UserLogin.vue";
import UserRegister from "./UserRegister.vue";

export default {
  name: "UserAuth",
  components: {
    UserLogin,
    UserRegister
  }
};
</script>
